import axiosInstance from "api/axiosInstance";

import type { AttendanceItem, AttendanceListParams } from "api/types/attendances.types";

const BASE = "/server/buccl_lessons/api/v2/attendances/";

export const attendancesService = {
  list: (params?: AttendanceListParams) => axiosInstance.get<AttendanceItem[]>(BASE, { params }),

  get: (id: number) => axiosInstance.get<AttendanceItem>(`${BASE}${id}/`),
};
